<template>
  <div>
    <app-latest-news :className="className" :title="name"></app-latest-news>
    <h4 class="container title">All news</h4>
    <div class="news-created-list container">
      <div class="news-box">
        <app-news v-for="(item, index) in newsExtend" :key="index" :item="item"></app-news>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
import Latest_news from "@/components/shared/Latest_news";
import News from "@/components/shared/News";

const BottomSection = () => import("@/components/shared/BottomSection");
const url = process.env.VUE_APP_URL;

export default {
  data() {
    return {
      className: "news-page",
      name: "top news",
    };
  },
  computed: {
    newsExtend() {
      return this.$store.getters.news;
    },
  },
  methods: {
    setNews() {
      this.axios
        .get(url + "/articles", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setNews", payload);
        });
    },
  },
  mounted() {
    this.setNews();
  },
  components: {
    "app-latest-news": Latest_news,
    "app-news": News,
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 0 5rem;
  &.title {
    padding-top: 9rem;
    @media only screen and (max-width: 768px) {
      padding-top: 5rem;
      padding-bottom: 2rem;
    }
  }
}
.title + .show-more {
  display: none;
}
</style>